<template>
  <div class="accordion-item">
    <div
      v-if="!slots.header"
      class="accordion-title cursor-pointer py-3 flex items-center justify-between hover:text-primary"
      @click="toggleItem"
    >
      <div class="text-2xl">{{ title }}</div>
      <Icon
        class="text-xl"
        :type="isOpen ? 'chevron-up' : 'chevron-down'"
      ></Icon>
    </div>
    <div
      v-else
      @click="toggleItem"
    >
      <slot name="header" />
    </div>
    <div
      v-show="isOpen"
      class="accordion-item-content pb-5"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icon/Icon.vue'
import { useSlots } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: 'Accordion Title'
  },
  isOpen: {
    type: Boolean,
    default: false
  }
})

/**
 * Emits definition with proper TypeScript types
 */
const emit = defineEmits(['update:isOpen'])

/**
 * Vue slots composable for checking if header slot exists
 */
const slots = useSlots()

/**
 * Toggles the accordion item's open/closed state
 * Emits an update event to the parent component
 */
function toggleItem(): void {
  try {
    emit('update:isOpen', !props.isOpen)
  } catch (error) {
    console.error('Error toggling accordion item:', error)
  }
}
</script>

<style>
.accordion-item {
  border-bottom: 1px solid var(--border-secondary);
}

.accordion > .accordion-item:last-of-type {
  border-bottom: none;
}
</style>
